import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.number.constructor";
import _map from "lodash/map";
import _isString from "lodash/isString";
import _isEmpty from "lodash/isEmpty";
import _isFinite from "lodash/isFinite";
import _get from "lodash/get";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { formatCurrency } from '@nerdwallet/nw-client-lib/num'; // Local utils

import logger from '../logger';
import isEmailValid from './validators/email';
import isPhoneNumberValid from './validators/phone-number';
import isUUIDValid from './validators/uuid';
import isZipCodeValid from './validators/zip-code';
import getStateFromZipCode from '../get-state-from-zip-code';
import { isPurchase } from '../mapping/helpers';
import validationResult from './result';
import { validateNumber, validateString, validateArray } from './types';
/**
 * The result of the validation
 * @typedef ValidationResult
 * @property {Boolean} valid
 * @property {String} message  The message
 */

export * from './types';
/**
 * If refinance, validates that cashout does not exceed their equity
 * @function
 * @param  {Object} data
 * @param  {external:home-constants.LOAN_PURPOSE} data.loanPurpose
 * @param  {Number} data.propertyValue
 * @param  {Number} data.mortgageBalance
 * @param  {Input} input
 * @return {ValidationResult}
 */

export var validateCashout = function validateCashout(data, input) {
  // isCashOutRefinance is only used by MRT so it will not always be supplied when validating cashout
  // for this reason, we check that it is explicitly equal to false and not just undefined/null
  if (isPurchase(data) || _get(data, 'isCashOutRefinance') === false) {
    return validationResult({
      valid: true
    });
  }

  var propertyValue = _get(data, 'propertyValue');

  var mortgageBalance = _get(data, 'mortgageBalance');

  var equity = propertyValue - mortgageBalance;

  var cashout = _get(data, 'cashout');

  if (equity <= 0 && cashout > 0) {
    return validationResult({
      valid: false,
      message: "For a cash-out refinance, mortgage balance needs to be no more than ".concat(formatCurrency(0.8 * propertyValue))
    });
  }

  return validateNumber(data, _objectSpread(_objectSpread({}, input), {}, {
    maximum: equity > 0 ? equity : undefined
  }));
};
/**
 * Validates if autocompleteState is true
 * @function
 * @param  {Object} data
 * @param  {Boolean} data.autocompleteState
 * @return {ValidationResult}
 */

export var validateAutocompleteState = function validateAutocompleteState(data) {
  return validationResult({
    valid: data.autocompleteState,
    message: 'Please enter a valid location'
  });
};
/**
 * Validates that propertyValue is not 0 with a custom message
 * @function
 * @param  {Object} data
 * @param  {Number} data.propertyValue
 * @param  {Input} input
 * @return {ValidationResult}
 */

export var validatePropertyValue = function validatePropertyValue(data, input) {
  return data.propertyValue === 0 ? validationResult({
    valid: false,
    message: 'This field is required'
  }) : validateNumber(data, input);
};
/**
 * Validates that purchasePrice is not 0 with a custom message
 * @function
 * @param  {Object} data
 * @param  {Number} data.purchasePrice
 * @param  {Input} input
 * @return {ValidationResult}
 */

export var validatePurchasePrice = function validatePurchasePrice(data, input) {
  return data.purchasePrice === 0 ? validationResult({
    valid: false,
    message: 'This field is required'
  }) : validateNumber(data, input);
};
/**
 * Validates that down payment is not greater than property value
 * @function
 * @param  {Object} data
 * @param  {Number} data.downPayment
 * @param  {Number} data.propertyValue
 * @return {ValidationResult}
 */

export var validateDownPayment = function validateDownPayment(data) {
  return !isPurchase(data) ? validationResult({
    valid: true
  }) : validationResult({
    valid: data.purchasePrice > 0 ? Number(data.downPayment) < Number(data.purchasePrice) : true,
    message: data.downPayment >= 0 ? 'Please enter an amount less than your home price' : 'This field is required'
  });
};
/**
 * Same as validateDownPayment except it has no message
 * @see {module:validations.validateDownPayment}
 * @function
 * @param  {Object} data
 * @param  {Number} data.downPayment
 * @param  {Number} data.propertyValue
 * @return {ValidationResult}
 */

export var validateDownPaymentPercent = function validateDownPaymentPercent(data) {
  return _objectSpread(_objectSpread({}, validateDownPayment(data)), {}, {
    message: ''
  });
};
/**
 * Validates that mortgage balance does not exceed property value
 * @function
 * @param  {Object} data
 * @param  {external:home-constants.LOAN_PURPOSE} data.loanPurpose
 * @param  {Number} data.propertyValue
 * @return {ValidationResult}
 */

export var validateMortgageBalance = function validateMortgageBalance(data, input) {
  return isPurchase(data) ? validationResult({
    valid: true
  }) : validateNumber(data, _objectSpread({}, input));
};
/**
 * Validates loanPrograms using validateArray with a custom error message
 * @function
 * @param  {Object} data
 * @param  {Input} input
 * @return {ValidationResult}
 */

export var validateLoanPrograms = function validateLoanPrograms(data, input) {
  var result = validateArray(data, input);

  if (!result.valid && _isEmpty(data.loanPrograms)) {
    result.message = 'Please choose at least one';
  }

  return result;
};
/**
 * Validates originationMonth is not in the past
 * @function
 * @param  {Object} data
 * @return {ValidationResult}
 */

export var validateOriginationMonth = function validateOriginationMonth(data) {
  if (!data.originationMonth) {
    return validationResult({
      valid: false,
      message: 'Please select an option'
    });
  }

  if (data.originationYear !== new Date().getFullYear()) {
    return validationResult({
      valid: true
    });
  }

  return validationResult({
    // getMonth is zero indexed and originationMonth is not so add 1
    valid: data.originationMonth <= new Date().getMonth() + 1,
    message: 'Are you a time traveler? Origination dates must be in the past.'
  });
};
/**
 * Validates originationDate is valid
 * @function
 * @param  {Object} data
 * @return {ValidationResult}
 */

export var validateOriginationDate = function validateOriginationDate(data) {
  if (!data.originationDate || !_isString(data.originationDate)) {
    return {
      valid: false,
      message: 'This field is required'
    };
  }

  if (data.originationDate.length !== 7) {
    return {
      valid: false,
      message: 'Please enter a valid date'
    };
  } // convert to numbers and then check below if either are NaN


  var _map2 = _map(data.originationDate.split('/'), Number),
      _map3 = _slicedToArray(_map2, 2),
      month = _map3[0],
      year = _map3[1];

  if (!month || !year || month < 1 || month > 12) {
    return {
      valid: false,
      message: 'Please enter a valid date'
    };
  }

  if (year < 1980) {
    return {
      valid: false,
      message: 'Year must be greater than 1980'
    };
  }

  if (year < new Date().getFullYear()) {
    return {
      valid: true
    };
  }

  return {
    // getMonth is zero indexed and originationMonth is not so add 1
    valid: year <= new Date().getFullYear() && month <= new Date().getMonth() + 1,
    message: 'Are you a time traveler? Origination dates must be in the past.'
  };
};
/**
 * String validation with custom message
 * @function
 * @param  {Object} data
 * @return {ValidationResult}
 */

export var validateFirstName = function validateFirstName(data, input) {
  return validationResult(_objectSpread(_objectSpread({}, validateString(data, input)), {}, {
    message: 'Please enter your first name'
  }));
};
/**
 * String validation with custom message
 * @function
 * @param  {Object} data
 * @return {ValidationResult}
 */

export var validateLastName = function validateLastName(data, input) {
  return validationResult(_objectSpread(_objectSpread({}, validateString(data, input)), {}, {
    message: 'Please enter your last name'
  }));
};
/**
 * Validates an e-mail address is correct format
 * @todo doesnt need to hard-code input name, see validateUuid
 * @function
 * @param  {Object} data
 * @param  {String} data.emailAddress
 * @return {ValidationResult}
 */

export var validateEmailAddress = function validateEmailAddress(data) {
  return validationResult({
    valid: isEmailValid(data.emailAddress),
    message: 'Please enter a valid email address'
  });
};
/**
 * Validates a phone number is 10 digits long
 * @todo hard-coded input name, see validateUuid
 * @function
 * @param  {Object} data
 * @param  {String} data.phoneNumber
 * @return {ValidationResult}
 */

export var validatePhoneNumber = function validatePhoneNumber(data) {
  return validationResult({
    valid: isPhoneNumberValid(data.phoneNumber),
    message: 'Please enter a valid U.S. number'
  });
};
/**
 * this validator is used is forms where there is a property value input but
 * not a mortgage balance input
 * @todo clarify, document what & why?
 * @function
 * @param  {Object} data
 * @param  {external:home-constants.LOAN_PURPOSE} data.loanPurpose
 * @param  {Number} data.mortgageBalance
 * @param  {Input} input
 * @return {ValidationResult}
 */

export var validatePropertyValueToMortgageBalance = function validatePropertyValueToMortgageBalance(data, input) {
  var mortgageBalance = _get(data, 'mortgageBalance');

  if (isPurchase(data)) {
    return validationResult({
      valid: true
    });
  }

  if (!_isFinite(mortgageBalance)) {
    return validateNumber(data, input);
  }

  var minimum = mortgageBalance;

  var value = _get(data, _get(input, 'name'));

  var validation = validateNumber(data, _objectSpread(_objectSpread({}, input), {}, {
    minimum: minimum
  }));

  if (!validation.valid && _isFinite(value) && value < minimum) {
    // custom error message if value < minimum
    return validationResult(_objectSpread(_objectSpread({}, validation), {}, {
      message: "Property value must be greater than mortgage balance, calculated at ".concat(formatCurrency(minimum), ", to refinance.")
    }));
  }

  return validation;
};
/**
 * Conditionally validates input as a number if hasBankruptcy is true
 * @function
 * @param  {Object} data
 * @param  {Boolean} data.hasBankruptcy
 * @param  {Input} input
 * @return {ValidationResult}
 * @function
 */

export var validateSinceLastBankruptcy = function validateSinceLastBankruptcy(data, input) {
  return !data.hasBankruptcy ? validationResult({
    valid: true
  }) : validateNumber(data, input);
};
/**
 * Conditionally validates input as a number if hasForeclosure is true
 * @function
 * @param  {Object} data
 * @param  {Boolean} data.hasForeclosure
 * @param  {Input} input
 * @return {ValidationResult}
 */

export var validateSinceLastForeclosure = function validateSinceLastForeclosure(data, input) {
  return !data.hasForeclosure ? validationResult({
    valid: true
  }) : validateNumber(data, input);
};
/**
 * Validates given uuid is in the correct format
 * @function
 * @param  {Object} data
 * @param  {Input}  input
 * @param  {String} input.name
 * @return {ValidationResult}
 */

export var validateUuid = function validateUuid(data, input) {
  return validationResult({
    valid: isUUIDValid(_get(data, _get(input, 'name'))),
    message: 'Invalid UUID'
  });
};
/**
 * Validates that the zipCode is 5 digits long and then checks against a service
 * @function
 * @param  {Object} data
 * @param  {String} data.zipCode
 * @return {ValidationResult}
 */

export var validateZipCode = function validateZipCode(_ref) {
  var zipCode = _ref.zipCode;
  var message = 'Please enter a valid U.S. ZIP code';

  if (!isZipCodeValid(zipCode)) {
    return validationResult({
      valid: false,
      message: message
    });
  }

  return new Promise(function (resolve) {
    getStateFromZipCode(zipCode).then(function (res) {
      var valid = !!res.state;
      resolve(validationResult({
        valid: valid,
        message: message
      }));
    })["catch"](function (err) {
      logger.error('validation: zipCode resolution', zipCode, err);
      resolve(validationResult({
        valid: true
      }));
    });
  });
};
/**
 * Validates loanStartDate is valid.
 *
 * @function
 * @param  {Object} data
 * @return {ValidationResult}
 */

export var validateLoanStartDate = function validateLoanStartDate(data) {
  // empty dates are valid, since they will reset to the default values
  if (!data.loanStartDate) {
    return {
      valid: true
    };
  } // If the date is incomplete it will contain placeholder texts e.g. 01 / 2D / YYYY


  var CONTAIN_LETTER = new RegExp(/[a-zA-Z]/);

  if (CONTAIN_LETTER.test(data.loanStartDate) || data.loanStartDate.length < 14) {
    return {
      valid: false,
      message: 'Please enter the full date.'
    };
  } // convert to numbers and then check below if either are NaN


  var _map4 = _map(data.loanStartDate.split('/'), Number),
      _map5 = _slicedToArray(_map4, 3),
      month = _map5[0],
      day = _map5[1],
      year = _map5[2];

  if (!day || !month || !year || day > 31 || month < 1 || month > 12) {
    return {
      valid: false,
      message: 'Please enter a valid date.'
    };
  }

  return {
    valid: true
  };
};